module.exports = __webpack_public_path__ + "static/media/logo-white.f86beaf3.svg";